import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Brand, Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";

function Result({ ok, title, text, to, cta, testId }) {
  const Icon = ok ? CheckCircle2 : XCircle;
  return (
    <div className="gt-card p-6" data-testid={testId}>
      <Icon className={`h-10 w-10 ${ok ? "text-emerald-500" : "text-red-500"}`} />
      <h2 className="mt-3 text-xl font-extrabold">{title}</h2>
      <p className="mt-2 text-sm text-muted-foreground">{text}</p>
      <Link to={to} className="mt-5 inline-block rounded-xl bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground" data-testid={`${testId}-link`}>{cta}</Link>
    </div>
  );
}

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [bad, setBad] = useState("");
  const [f, setF] = useState({ pw: "", confirm: "" });
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/reset-password/verify", { params: { token } }).then((r) => setInfo(r.data)).catch((e) => setBad(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.pw !== f.confirm) return setErr("Konfirmasi password tidak sama");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, new_password: f.pw }); setDone(true); } catch (ex) { setErr(errMsg(ex)); }
    setBusy(false);
  };

  let body;
  if (bad) body = <Result title="Link tidak bisa dipakai" text={bad} to="/forgot-password" cta="Minta link baru" testId="reset-invalid" />;
  else if (done) body = <Result ok title="Password tersimpan" text="Silakan masuk dengan password baru Anda." to="/login" cta="Masuk" testId="reset-success" />;
  else if (!info) body = <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" data-testid="reset-loading" />;
  else body = (
    <form onSubmit={submit} data-testid="reset-form">
      <div className="gt-eyebrow mb-3">{info.purpose === "invite" ? "Aktivasi akun" : "Password baru"}</div>
      <h2 className="text-3xl font-extrabold tracking-tight">{info.purpose === "invite" ? "Buat password Anda" : "Atur ulang password"}</h2>
      <p className="mt-2 text-sm text-muted-foreground" data-testid="reset-account">Halo {info.name}, buat password untuk <b>{info.email}</b>.</p>
      <div className="mt-7 space-y-3.5">
        <Field label="Password baru (min 8 karakter)"><input type="password" required minLength={8} value={f.pw} onChange={(e) => setF({ ...f, pw: e.target.value })} className="gt-input h-11" data-testid="reset-password-input" /></Field>
        <Field label="Ulangi password"><input type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="gt-input h-11" data-testid="reset-confirm-input" /></Field>
        {err && <div className="rounded-xl border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-500" data-testid="reset-error">{err}</div>}
        <button disabled={busy} className="h-12 w-full rounded-xl bg-primary font-bold text-primary-foreground transition-opacity hover:opacity-95 disabled:opacity-60" data-testid="reset-submit-button">{busy ? "Menyimpan..." : "Simpan password"}</button>
      </div>
    </form>
  );

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-sm gt-rise"><Brand className="mb-10" />{body}</div>
    </div>
  );
}
